export default "__VITE_ASSET__DaDdkXAk__"